import { authRoles } from './auth/authRoles'
// Keep icons as string keys; render actual components in UI layer
export const navigations = [

    {
        name: 'Dashboard',
        path: '/',
        icon: 'home',
        auth: authRoles.user,
    },
    // {
    //     name: 'Exporter',
    //     path: '/viewer',
    //     icon: 'exit_to_app',
    //     auth: authRoles.user,
    // }

]

export const resourceNavigations = [
    {
        name: 'Resources',
        auth: authRoles.user,
        children: [

            {
                name: 'Knowledge Base',
                icon: 'launch',
                type: 'extLink',
                path: 'https://argylebuild.notion.site/50573beac8d14e8fbd3db103b6294b87?v=abfecdf2169a458e8f75dff73bde777f&pvs=4',
                auth: authRoles.user,
            },
            {
                name: 'Revit & Navisworks Plugin',
                icon: 'extension',
                type: 'extLink',
                path: 'https://www.argyle.build/download',
                auth: authRoles.user,
            },
            {
                name: 'Get the AR App',
                icon: 'star',
                type: 'extLink',
                path: 'https://argylebuild.notion.site/Get-the-AR-App-8fec21f155ee4c19b1321dd8381a8800',
                auth: authRoles.user,
            },
        ]
    },
]

export const AdminNavigations = [
    {
        label: 'Management',
        type: 'label',
        auth: authRoles.admin,
    }, {
        name: 'Admin',
        children: [
            {
                name: 'Overview',
                path: '/admin',
                icon: 'home',
                auth: authRoles.admin,
            },
            {
                name: 'Analytics',
                path: '/admin/dashboard',
                icon: 'insights',
                auth: authRoles.admin,
            },
            {
                name: 'Organizations',
                path: '/admin/manage-orgs',
                icon: 'group_work',
                auth: authRoles.admin,
            },
            {
                name: 'Projects',
                path: '/admin/manage-sites',
                icon: 'dashboard',
                auth: authRoles.admin,
            },
            {
                name: 'Users',
                path: '/admin/manage-users',
                auth: authRoles.admin,
                icon: 'person',
            }
        ],
    },
]

export const siteNavigations = (siteId) => [
    {
        label: 'Project Navigation',
        type: 'label',
        auth: authRoles.user,
    },
    {
        name: 'Observations',
        path: `/site/${siteId}?tab=observations`,
        icon: 'visibility',
        auth: authRoles.user,
    },
    {
        name: 'Users',
        path: `/site/${siteId}?tab=users`,
        icon: 'people',
        auth: authRoles.user,
    },
    {
        name: 'AR Media',
        path: `/site/${siteId}?tab=photos`,
        icon: 'photo',
        auth: authRoles.user,
    },
    {
        name: 'QR Codes',
        path: `/site/${siteId}?tab=qr`,
        icon: 'qr_code',
        auth: authRoles.user,
    },
    {
        name: 'Models',
        path: `/site/${siteId}?tab=model`,
        icon: 'view_in_ar',
        auth: authRoles.user,
    },
]

export const OrgNavigations = (orgId) => [
    //org specific navigation menu
    {
        label: 'Organization Navigation',
        type: 'label',
        auth: authRoles.user,
    },
    {
        name: 'Projects',
        path: `/org/${orgId}`,
        icon: 'dashboard',
        auth: authRoles.user,
    },
    {
        name: 'Users',
        path: `/org/${orgId}/users`,
        icon: 'people',
        auth: authRoles.user,
    },
]
